export enum modalResponse {
  approve= 1,
  decline= 2,
  action= 3
}
